import React from "react";
import { Table } from "reactstrap";
import { array } from "prop-types";

import WatchListUpdateReportTableRow from "./row";

const WatchListUpdateReportTable = ({ watchListUpdateLogs }) => {
  const rows = watchListUpdateLogs.map((entry) => (
    <WatchListUpdateReportTableRow key={entry.id} entry={entry} />
  ));

  return (
    <Table className="watch-list-updates-entries-table  p-0">
      <thead className="thead-light">
        <tr>
          <th className="text-center">ID</th>
          <th>Name</th>
          <th>Date</th>
          <th className="text-center">Active</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};

WatchListUpdateReportTable.propTypes = {
  watchListUpdateLogs: array.isRequired,
};

export default WatchListUpdateReportTable;



// WEBPACK FOOTER //
// ./src/features/reports/pages/watch-list-update-report/table/WatchListUpdateReportTable.jsx